export const sanitize = (str) =>
    str.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 60);
  
  export const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
  
  export const audioDuration = (blob) =>
    new Promise((resolve) => {
      const a = new Audio();
      a.src = URL.createObjectURL(blob);
      a.onloadedmetadata = () => resolve(a.duration || 0);
    });
  
  export const playAudioFromBlob = (blob) =>
    new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.src = URL.createObjectURL(blob);
      audio.onended = resolve;
      audio.onerror = reject;
      audio.play();
    });
  